import { categories } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20editorial%20flat%20lay%20composition%20featuring%20a%20curated%20selection%20of%20clothing%20items%20a%20cream%20linen%20blazer%20sage%20green%20knit%20sweater%20tan%20leather%20loafers%20and%20minimalist%20gold%20accessories%20arranged%20on%20a%20warm%20sandstone%20textured%20surface%20soft%20diffused%20natural%20window%20light%20from%20upper%20left%20creating%20gentle%20angular%20shadows%20warm%20neutral%20palette%20with%20subtle%20olive%20and%20terracotta%20accents%20sophisticated%20clean%20aesthetic%20high%20end%20product%20photography%20style%20high%20detail%20harmonious%20composition&width=1600&height=900&seq=hero-main-2026-jun-v2&orientation=landscape"
        alt="Pandabuy Spreadsheet curated fashion collection featuring premium clothing and accessories in warm neutral tones"
        title="Best Pandabuy Spreadsheet Collection 2026 fashion products"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/55 via-black/30 to-black/10"></div>

      <div className="relative z-10 w-full px-6 md:px-10 lg:px-16">
        <div className="max-w-2xl">
          <span className="inline-block px-3 py-1 rounded-full border border-white/40 text-white/90 text-xs md:text-sm font-medium mb-5 md:mb-6 whitespace-nowrap animate-fade-in">
            2026 Updated Collection
          </span>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 md:mb-5 animate-fade-in-up">
            Best Pandabuy Spreadsheet Collection
          </h1>
          <p className="text-white/80 text-sm md:text-base leading-relaxed max-w-lg mb-7 md:mb-8 animate-fade-in-up animation-delay-100">
            Discover the latest Pandabuy Spreadsheet with trusted sellers, popular finds, quality guides, and safe shopping resources — updated daily with trending fashion, sneakers, clothing, and accessories.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 animate-fade-in-up animation-delay-200">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold whitespace-nowrap hover:bg-primary-600 transition-all cursor-pointer"
            >
              Pandabuy Sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-white/15 backdrop-blur-sm border border-white/30 text-white text-sm md:text-base font-semibold whitespace-nowrap hover:bg-white/25 transition-all cursor-pointer"
            >
              Buy It Now
              <i className="ri-shopping-bag-line"></i>
            </a>
          </div>

          <div className="flex flex-wrap gap-2 mt-7 md:mt-8 animate-fade-in-up animation-delay-300">
            {categories.slice(0, 6).map((cat) => (
              <a
                key={cat.slug}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="px-3 py-1.5 rounded-full border border-white/25 text-white/85 text-xs font-medium whitespace-nowrap hover:bg-white/15 hover:border-white/40 transition-all cursor-pointer"
              >
                {cat.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}